<template>
  <div>
    <data-local-table
      :fields="fields"
      :items="value"
    >
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <v-btn
          x-small
          color="primary"
          @click="showEditDialog(slotData.rowIndex, slotData.rowData)"
        >Edit</v-btn>
      </template>
    </data-local-table>
    <v-btn
      color="primary"
      small
      @click="showAddDialog()"
    >
      Add rent
    </v-btn>
    <modal-form
      title="Rent"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
    >
      <v-form v-model="valid">
        <v-row>
          <v-col cols="4">
            <type-rent
              :readonly="isReadOnly()"
              label="Type of rent"
              :value="getValue(item, 'type_of_rent')"
              @input="setValue(item, 'type_of_rent', $event)"
              ref="trent"
            ></type-rent>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Start date"
              :value="getValue(item, 'start_date')"
              @input="setValue(item, 'start_date', $event)"
            ></date-picker>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Last change date"
              :value="getValue(item, 'last_change_date')"
              @input="setValue(item, 'last_change_date', $event)"
            ></date-picker>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="End date"
              :value="getValue(item, 'end_date')"
              @input="setValue(item, 'end_date', $event)"
            ></date-picker>
          </v-col>
          <v-col cols="4">
            <currency-field
              :readonly="isReadOnly()"
              label="Revenue"
              :value="getValue(item, 'revenue')"
              @input="setValue(item, 'revenue', $event)"
            ></currency-field>
          </v-col>
          <v-col cols="4">
            <payment-schedule
              :readonly="isReadOnly()"
              label="Revenue period"
              :value="getValue(item, 'revenue_period_id')"
              @input="setValue(item, 'revenue_period_id', $event)"
            ></payment-schedule>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <s-textarea
              :readonly="isReadOnly()"
              label="Comments"
              :value="getValue(item, 'comments')"
              @input="setValue(item, 'comments', $event)"
            ></s-textarea>
          </v-col>
        </v-row>
        <template v-if="item.type_of_rent == 'tower'">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Used space on tower, number and type of antenna"
                :value="getValue(item, 'used_space_number_type_antenna')"
                @input="setValue(item, 'used_space_number_type_antenna', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Used space on tower, number and type of RRU"
                :value="getValue(item, 'used_space_tower_type_rru')"
                @input="setValue(item, 'used_space_tower_type_rru', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Used space on tower, number and type of MW"
                :value="getValue(item, 'used_space_tower_type_mw')"
                @input="setValue(item, 'used_space_tower_type_mw', $event)"
              ></text-field>
            </v-col>
          </v-row>
        </template>
        <template v-if="item.type_of_rent == 'room'">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Used space in equipment room"
                :value="getValue(item, 'used_space_equipment_room')"
                @input="setValue(item, 'used_space_equipment_room', $event)"
              ></text-field>
            </v-col>
          </v-row>
        </template>
        <template v-if="item.type_of_rent == 'rack'">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Used space in rack"
                :value="getValue(item, 'used_space_rack')"
                @input="setValue(item, 'used_space_rack', $event)"
              ></text-field>
            </v-col>
          </v-row>
        </template>
        <template v-if="item.type_of_rent == 'ac_supply'">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Main Fuse, AC power supply"
                :value="getValue(item, 'main_fuse_ac_power_supply')"
                @input="setValue(item, 'main_fuse_ac_power_supply', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Limiter type, AC power supply"
                :value="getValue(item, 'limiter_type_ac_power_supply')"
                @input="setValue(item, 'limiter_type_ac_power_supply', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Leased power, AC power supply"
                :value="getValue(item, 'leased_type_ac_power_supply')"
                @input="setValue(item, 'leased_type_ac_power_supply', $event)"
              ></text-field>
            </v-col>
          </v-row>
        </template>
        <template v-if="item.type_of_rent == 'dc_supply'">
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Main Fuse, DC power supply"
                :value="getValue(item, 'main_fuse_dc_power_supply')"
                @input="setValue(item, 'main_fuse_dc_power_supply', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnly()"
                label="Leased power, DC power supply"
                :value="getValue(item, 'leased_power_dc_power_supply')"
                @input="setValue(item, 'leased_power_dc_power_supply', $event)"
              ></text-field>
            </v-col>
          </v-row>
        </template>
      </v-form>
    </modal-form>

  </div>
</template>

<script>
  import TypeRent from '@/components/codelist/TypeRent'
  import DatePicker from '@/components/DatePicker'
  import CurrencyField from '@/components/CurrencyField'
  import PaymentSchedule from '@/components/codelist/PaymentSchedule'
  import STextarea from '@/components/Textarea'
  import TextField from '@/components/TextField'
  import ReactivityMixin from '@/mixins/Reactivity'
  import ModalForm from '@/components/ModalForm'
  import DataLocalTable from '@/components/DataLocalTable'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'Rents',
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    components: { DataLocalTable, ModalForm, TextField, STextarea, PaymentSchedule, CurrencyField, DatePicker, TypeRent },
    props: {
      value: {
        default: [],
      },
      site: {},
    },
    data: () => ({
      valid: false,
      dialog: false,
      selected_index: -1,
      item: {},
      fields: [
        {
          name: 'type_of_rent_name',
          title: 'Type of rent',
        },
        {
          name: 'start_date',
          title: 'Start date',
        },
        {
          name: 'end_date',
          title: 'End date',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
      section: 'tenant',
    }),
    computed: {
      isEditing () {
        return this.selected_index > -1
      },
    },
    watch: {
      value: function () {
        this.$emit('input', this.value)
      },
    },
    methods: {
      showAddDialog () {
        this.selected_index = -1
        this.item = {}
        this.dialog = true
      },
      showEditDialog (index, item) {
        this.item = item
        this.selected_index = index
        this.dialog = true
      },
      doSave () {
        if (this.isEditing) {
          this.item.type_of_rent_name = this.$refs.trent.getValueTitle(this.item.type_of_rent)
          this.value[this.selected_index] = this.item
          this.dialog = false
        } else {
          this.value.push(this.item)
          this.dialog = false
        }
      },
    },
  }
</script>

<style scoped>

</style>
